import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar as faStarSolid } from '@fortawesome/pro-solid-svg-icons';
import { faStar as faStarRegular } from '@fortawesome/pro-regular-svg-icons';
import classes from './RatingStars.module.scss';

type Rating05 = 0 | 1 | 2 | 3 | 4 | 5;

export interface RatingStarsProps {
    value: Rating05; // 0-5
    onChange: (value: Rating05) => void;
    className?: string;
    size?: number; // px
}

const RatingStars: React.FC<RatingStarsProps> = ({ value, onChange, className, size = 36 }) => {
    const [hoverValue, setHoverValue] = React.useState<Rating05>(0);
    const stars = [1, 2, 3, 4, 5] as const;

    return (
        <div
            className={`${classes.container} ${className || ''}`.trim()}
            onMouseLeave={() => setHoverValue(0)}
        >
            {stars.map(n => {
                const isActive = n <= (hoverValue || value);
                const icon = isActive ? faStarSolid : faStarRegular;
                return (
                    <FontAwesomeIcon
                        key={n}
                        icon={icon}
                        onMouseEnter={() => setHoverValue(n)}
                        onClick={() => onChange(n)}
                        className={`${classes.star} ${isActive ? classes.active : ''}`.trim()}
                        style={{ width: size, height: size }}
                    />
                );
            })}
        </div>
    );
};

export default RatingStars;
